/* Versão atual do Sisare Web */
export const APP_VERSION = '1.0.0.8'; // alterar a cada nova publicação/release 02/10/2026